import { resourceType, RESOURCE_NAME_SEPARATOR } from "./manage-permission";

/**
 * Filters a permissions list by carrier name (case-insensitive partial match
 * against the first element of each componentKeyValues entry).
 */
export function filterByCarrierName(
  permissionsList: any[],
  carrierName: string,
): any[] {
  const updatedCarrierName = carrierName?.trim();
  if (!updatedCarrierName) {
    return permissionsList;
  }
  return permissionsList?.filter((requestedPermission) =>
    requestedPermission?.componentKeyValues?.some((componentKeyValue) => {
      const name = componentKeyValue[0] || "";
      return name?.toLowerCase()?.includes(updatedCarrierName?.toLowerCase());
    }),
  );
}

/**
 * Transforms raw resourcePermissions from the API into a flattened structure
 * with componentKeyValues, countryCode, businessUnit, views, and transitTimeType.
 */
export function transformRequestedResourcePermissions(requestedResourcePermissions) {
  if (!requestedResourcePermissions) return [];
    return requestedResourcePermissions.map((requestedResourcePermission) => {
      let requestedResourceObj = {
        ...requestedResourcePermission,
        componentKeyValues:
          requestedResourcePermission?.requestedPermissions?.map(
            (requestedPermission) => {
              return requestedPermission?.resourceName?.split(RESOURCE_NAME_SEPARATOR).slice(2);
            },
          ),
      };

      if (requestedResourcePermission?.requestedPermissions?.length > 0) {
        const requestedPermission =
          requestedResourcePermission?.requestedPermissions[0];

        const resourceNameList = requestedPermission?.resourceName?.split(RESOURCE_NAME_SEPARATOR);

        requestedResourceObj = {
          ...requestedResourceObj,
          countryCode: resourceNameList[0],
          businessUnit: resourceNameList[1],
        };

        if (
          requestedPermission?.resourceType ===
          resourceType?.ComponentKeyValueResourceType
        ) {
          const templateMap = requestedPermission?.templates?.map(
            (template) => {
              // Match: "can_<action>" followed by "_<UPPERCASE_RESOURCE>"
              const match = template?.match(/^(can_[a-z]+)_(.+)$/);
              if (!match) {
                return { view: null, transitTimeType: null };
              }
              return { view: match[1], transitTimeType: match[2] };
            },
          );
          requestedResourceObj = {
            ...requestedResourceObj,
            views: templateMap.map((template) => template?.view),
            transitTimeType: templateMap[0]?.transitTimeType,
          };
        } else {
          const templateMap = requestedPermission?.templates?.map(
            (template) => {
              // Match: "can_<action>" followed by "_<UPPERCASE_RESOURCE>"
              const match = template?.match(/^(can_[a-z]+)_(.+)$/);
              if (!match) {
                return { operation: null, view: null };
              }
              return { operation: match[1], view: match[2] };
            },
          );
          requestedResourceObj = {
            ...requestedResourceObj,
            views: templateMap.map((template) => template?.view),
          };
        }
      }

      return requestedResourceObj;
    });
  }

